// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Unibrow-cls1___eab047161ac70eb734d{/*!*/}.Unibrow-cls2__e1b713bbcfd6092b2eb0{white-space:nowrap}@media(max-width: 567px){.Unibrow-cls2__e1b713bbcfd6092b2eb0{width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Unibrow-cls1___eab047161ac70eb734d",
	"cls2": "Unibrow-cls2__e1b713bbcfd6092b2eb0 Unibrow-cls1___eab047161ac70eb734d"
};
export default ___CSS_LOADER_EXPORT___;
